module.exports = __webpack_public_path__ + "img/thumb_certificado_full.8665e56f.png";